/**
 * /tenants/$slug/agents/protected-resources — the tenant's protected-resource registry.
 */

import { createFileRoute } from "@tanstack/react-router";
import { fetchProtectedResources } from "@/features/agents/queries";
import { queryKeys } from "@/lib/query-keys";
import { AgentProtectedResourcesPage } from "@/features/agents/pages/agent-protected-resources-page";
import { protectedResourceSetupSearchSchema } from "@/features/agents/schemas";

export const Route = createFileRoute("/_authed/tenants/$slug/agents/protected-resources")({
  validateSearch: protectedResourceSetupSearchSchema,
  loaderDeps: ({ search }) => ({ q: search.q, page: search.page, protocol: search.protocol }),
  // Prefetch so the registry list is warm on navigation (sibling-route idiom).
  loader: ({ context, deps }) =>
    context.queryClient.ensureQueryData({
      queryKey: [...queryKeys.agents.protectedResources(context.tenant.id), deps],
      queryFn: () => fetchProtectedResources(context.tenant.id, deps),
    }),
  component: AgentProtectedResourcesPage,
});
